
//Auth 
export var count = 1
export const VIDEO_CHAT = '/';
export const FEEDBACK = '/feedback';